const e = {
  add: "Adicionar",
  cancel: "Cancelar",
  clear: "Limpar",
  confirm: "Confirmar",
  delete: "Excluir",
  redo: "Refazer",
  save: "Salvar",
  saveAs: "Salvar como",
  undo: "Desfazer"
}, a = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, o = {
  cancel: "Cancelar",
  confirm: "Confirmar",
  datePlaceholder: "Selecionar a data",
  datetimePlaceholder: "Selecionar a data e a hora",
  endDatePlaceholder: "Data de término",
  endDatetimePlaceholder: "Data e hora de término",
  endMonthPlaceholder: "Mês de término",
  monthPlaceholder: "Selecione o Mês",
  now: "Agora",
  quarterPlaceholder: "Selecione o Trimestre",
  selectDate: "Selecionar a data",
  selectTime: "Selecionar a hora",
  startDatePlaceholder: "Data de início",
  startDatetimePlaceholder: "Data e hora de início",
  startMonthPlaceholder: "Mês de Início",
  today: "Hoje",
  weekPlaceholder: "Selecionar a semana",
  yearPlaceholder: "Selecione o Ano",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, r = {
  placeholder: "Selecione"
}, l = {
  clear: "Limpar",
  negativeText: "Cancelar",
  now: "Agora",
  placeholder: "Selecionar a hora",
  positiveText: "OK"
}, t = {
  placeholder: "Insira"
}, n = {
  placeholder: "Insira"
}, s = {
  placeholder: "Comece a digitar..."
}, c = {
  allRows: "Todas as linhas",
  default: "Padrão",
  deleteLayoutDescription: "Você tem certeza de que deseja excluir este layout?",
  discardChanges: "Descartar alterações",
  discardLayoutChanges: "Descartar alterações de layout",
  enterLayoutName: "Digite o nome do layout",
  enterRowNumber: "Digite o número de linhas",
  fieldsSelected: "campos selecionados",
  freezeColumnDescription: "Congele a coluna à esquerda",
  freezeUptoColumn: "Congele até a coluna",
  frozen: "Congelado",
  layoutName: "Nome do Layout",
  manageColumns: "Gerenciar colunas",
  none: "Nenhum",
  reorderRows: "Reordenar linhas",
  rowsSelected: "linhas selecionadas",
  saveLayoutAs: "Salvar layout como",
  saveLayoutNew: "Salvar novo layout",
  search: "Pesquisar",
  searchColumnsPlaceholder: "Pesquisar colunas",
  searchFieldsPlaceholder: "Campos de pesquisa",
  selectAll: "Selecionar tudo",
  setTableHeight: "Definir a altura da mesa",
  unfreeze: "Descongelar",
  unsavedChanges: "Você tem alterações não salvas",
  unsavedChangesDescription: "Pode haver uma ou mais alterações não salvas. Você quer salvá-las?"
}, d = {
  at: "em",
  colorAlreadyUsed: "Selecione uma cor diferente ou use a atual",
  colorNamePlaceholder: "Insira o nome",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Escolha um nome de cor diferente",
  noColorsAdded: "Você não tem nenhuma cor nesta seção."
}, i = {
  searchPlaceholder: "Pesquisar"
}, u = {
  invalidPastedData: "Dados colados inválidos"
}, m = {
  of: "de",
  page: "Página",
  rowsPerPage: "Linhas por página"
}, p = {
  failedToUpload: "Falha ao carregar",
  retry: "Tentar de novo",
  clickToUpload: "clicar para Carregar",
  orDragAndDrop: "Ou Arrastar e soltar",
  supportedFileTypes: "Tipos de arquivo compatíveis:"
}, h = {
  global: e,
  Progress: a,
  DatePicker: o,
  Select: r,
  TimePicker: l,
  Input: t,
  InputNumber: n,
  InputTag: s,
  HLDataTable: c,
  ColorPicker: d,
  InputPhone: i,
  InputOtp: u,
  Pagination: m,
  Upload: p
};
export {
  d as ColorPicker,
  o as DatePicker,
  c as HLDataTable,
  t as Input,
  n as InputNumber,
  u as InputOtp,
  i as InputPhone,
  s as InputTag,
  m as Pagination,
  a as Progress,
  r as Select,
  l as TimePicker,
  p as Upload,
  h as default,
  e as global
};
